import React from "react";
import { useTranslation } from "react-i18next";
import styles from "./filters.module.scss";
import {
  UseFilterCleareAllFunc,
  UseFilterRemoveFunc,
} from "../../../hooks/useFilters";
import clear from "../../../images/close-filters-list.svg";
import { TableFilters } from "../../../utils/filters-for-table";
import { filter } from "lodash";

interface Props {
  activeFilters?: { name: string; id: number }[];
  removeFilter?: UseFilterRemoveFunc;
  closeFunc?: () => void;
  clearAll?: UseFilterCleareAllFunc;
  // table props
  tableMode?: boolean;
  filters?: TableFilters;
  setFilters?: (arg: TableFilters) => void;
}

export function Filters({
  activeFilters,
  removeFilter,
  closeFunc,
  clearAll,
  tableMode,
  filters,
  setFilters,
}: Props) {
  const tableClearAll = () => {
    setFilters!({});
  };

  const removeTableFilter = (filter: string) => {
    let res = structuredClone(filters);
    // @ts-ignore
    delete res[filter];
    // @ts-ignore
    setFilters(res)
  };

  const { t } = useTranslation();
  
  return (
    <div className={styles.filters}>
      <div className={styles.filtersHeader}>
        <h2 className={styles.filtersTitle}>{t('filters.title')}</h2>
        <div className={styles.filtersHeaderButtons}>
          <button
            className={styles.filtersClearAll}
            onClick={tableMode ? tableClearAll : clearAll}
          >
            {t('filters.clearAll')} <img src={clear} alt="clear" />
          </button>
        </div>
      </div>
      <ul className={styles.activeFiltersList}>
        {tableMode
          ? Object.entries(filters!).map((item) => (
              <li className={styles.activeFiltersItem} key={item[0]} onClick={() => removeTableFilter(item[0])}>
                <span>{item[1]}</span>
                <button></button>
              </li>
            ))
          : activeFilters!.map((item) => (
              <li className={styles.activeFiltersItem} key={item.id}>
                <span>{item.name}</span>
                <button onClick={() => removeFilter!(item.id)}></button>
              </li>
            ))}
      </ul>
    </div>
  );
}
